import React from "react";
import { Switch, Card, Group, Title } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import toast from "react-hot-toast";

export default function AffiliateStatus({ affiliateId, fetchData, status }) {
  const mutation = useMutation({
    mutationFn: async () =>
      axios
        .post(`/affiliates/${affiliateId}/toggle-status/`, {
          affiliate_id: affiliateId,
        })
        .then(({ data }) => {
          fetchData();
        })
        .catch((err) => {
          toast.error(err);
        }),
  });

  return (
    <React.Fragment>
      <Group spacing="xs">
        <Switch
          checked={status === 1}
          onChange={() => mutation.mutate()}
          label={status === 1 ? "Active" : "Inactive"}
        />
      </Group>
    </React.Fragment>
  );
}
